module.exports = __webpack_public_path__ + "static/media/3. Brotar, Esmalte y óleo en tela, 185 x 140 cm, 2016 copy.16343a0a.png";